import React, { useEffect, useState, useRef, lazy, createElement } from 'react';
import { Box, Container, Heading, Text, VStack, Flex, Image, Table, Tbody, Tr, Td, Icon } from '@chakra-ui/react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
interface AdvertorialPageProps {
  checkoutUrl?: string;
}
export function AdvertorialPage({
  checkoutUrl = 'https://pay.hotmart.com/G105090565O?checkoutMode=10'
}: AdvertorialPageProps) {
  // Meta Pixel Initialization
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const initPixel = () => {
      !function (f: any, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.head;
        if (s) {
          s.appendChild(t);
        }
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq?.('init', '1461988308668328');
      (window as any).fbq?.('track', 'PageView');
    };
    initPixel();
  }, []);
  const handleCheckoutClick = () => {
    ;
    (window as any).fbq?.('track', 'InitiateCheckout');
  };
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const handlePlayVideo = () => {
    setIsVideoPlaying(true);
    setTimeout(() => {
      videoRef.current?.play();
    }, 100);
  };
  // Countdown timer
  const [timeLeft, setTimeLeft] = useState({
    hours: 5,
    minutes: 38,
    seconds: 20
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        const totalSeconds = prev.hours * 3600 + prev.minutes * 60 + prev.seconds - 1;
        if (totalSeconds <= 0) return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        return {
          hours: Math.floor(totalSeconds / 3600),
          minutes: Math.floor(totalSeconds % 3600 / 60),
          seconds: totalSeconds % 60
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  // Purchase notifications
  const purchases = [{
    name: 'Ana García',
    city: 'CDMX, México',
    time: 'hace 2 min'
  }, {
    name: 'Roberto López',
    city: 'Monterrey, México',
    time: 'hace 5 min'
  }, {
    name: 'María Hernández',
    city: 'Guadalajara, México',
    time: 'hace 8 min'
  }, {
    name: 'José Martínez',
    city: 'Puebla, México',
    time: 'hace 12 min'
  }, {
    name: 'Laura Sánchez',
    city: 'Cancún, México',
    time: 'hace 15 min'
  }, {
    name: 'Carlos Ramírez',
    city: 'Tijuana, México',
    time: 'hace 18 min'
  }, {
    name: 'Patricia Flores',
    city: 'Mérida, México',
    time: 'hace 22 min'
  }, {
    name: 'Diego Torres',
    city: 'León, México',
    time: 'hace 25 min'
  }];
  const [showNotification, setShowNotification] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(0);
  useEffect(() => {
    const showNext = () => {
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
        setTimeout(() => {
          setCurrentPurchase(prev => (prev + 1) % purchases.length);
        }, 500);
      }, 4000);
    };
    const initialDelay = setTimeout(showNext, 8000);
    const interval = setInterval(showNext, 12000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <Box bg="#0f172a" bgImage="radial-gradient(circle at 50% 0%, rgba(255, 184, 0, 0.08) 0%, transparent 50%), radial-gradient(circle at 50% 100%, rgba(255, 184, 0, 0.05) 0%, transparent 50%)" minH="100vh" color="whiteAlpha.900" fontFamily="'Inter', system-ui, sans-serif" data-id="element-256">
      {/* Sticky Top Bar */}
      <Box position="fixed" top={0} left={0} right={0} zIndex={999} bgGradient="linear(to-r, #d4a017, #ffd700, #d4a017)" py={2} px={4} boxShadow="0 2px 10px rgba(0,0,0,0.3)" data-id="element-257">
        <Flex maxW="3xl" mx="auto" align="center" justify="center" gap={{
        base: 2,
        md: 4
      }} flexWrap="wrap" data-id="element-258">
          <Flex align="center" gap={2} data-id="element-259">
            <Text fontSize={{
            base: 'xs',
            md: 'sm'
          }} color="#0f172a" fontWeight="black" letterSpacing="wide" data-id="element-260">
              ⚡ PRECIO DE LANZAMIENTO: $28.88
            </Text>
          </Flex>
          <Flex align="center" gap={2} data-id="element-261">
            <Text fontSize={{
            base: 'xs',
            md: 'sm'
          }} color="#0f172a" fontWeight="medium" data-id="element-262">
              Sube a $247 el{' '}
              {new Date(Date.now() + 86400000).toLocaleDateString('es-MX', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
            </Text>
            <Box bg="#0f172a" color="#ffd700" px={2} py={0.5} borderRadius="md" fontSize={{
            base: 'xs',
            md: 'sm'
          }} fontWeight="black" fontFamily="monospace" letterSpacing="wider" data-id="element-263">
              {pad(timeLeft.hours)}:{pad(timeLeft.minutes)}:
              {pad(timeLeft.seconds)}
            </Box>
          </Flex>
        </Flex>
      </Box>

      {/* Spacer for fixed bar */}
      <Box h={{
      base: '70px',
      md: '50px'
    }} data-id="element-264" />

      <Container maxW="3xl" py={{
      base: 4,
      md: 12
    }} pb={{
      base: 32,
      md: 20
    }} data-id="element-265">
        <VStack spacing={{
        base: 6,
        md: 10
      }} align="stretch" data-id="element-266">
          {/* 1. HEADLINE */}
          <Box textAlign="center" data-id="element-267">
            <Text color="#ffd700" fontWeight="bold" letterSpacing="widest" mb={2} fontSize="xs" textTransform="uppercase" display="inline-block" borderBottom="1px solid rgba(255, 215, 0, 0.3)" pb={1} data-id="element-268">
              DESCUBRIMIENTO RECIENTE
            </Text>
            <Heading as="h1" fontSize={{
            base: '2xl',
            md: '5xl',
            lg: '6xl'
          }} fontWeight="black" lineHeight="1.1" mb={2} fontFamily="'Playfair Display', Georgia, serif" bgGradient="linear(to-b, #ffffff, #e2e8f0)" bgClip="text" textShadow="0 0 30px rgba(255, 255, 255, 0.1)" data-id="element-269">
              Revela por qué el 97% de los rituales de abundancia fallan… y cómo
              activar el dinero en menos de 7 días usando el{' '}
              <Text as="span" color="#ffd700" bgClip="unset" textShadow="0 0 20px rgba(255, 215, 0, 0.4)" data-id="element-270">
                Código 888
              </Text>
            </Heading>
          </Box>

          {/* 2. VIDEO */}
          <Box w="100%" position="relative" borderRadius="2xl" overflow="hidden" border="1px solid rgba(255, 215, 0, 0.2)" boxShadow="0 20px 50px -12px rgba(255, 184, 0, 0.25)" sx={{
          aspectRatio: '16 / 9'
        }} _before={{
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.1)',
          borderRadius: '2xl',
          pointerEvents: 'none',
          zIndex: 1
        }} data-id="element-271">
            <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/pEdNTtgPC4Cc8vhyagpk9i/invideo-ai-720%20Este%20888%20desbloquea%20tu%20dinero%20en%20d%C3%ADas%202026-04-02%20(1)%20(1).mp4" poster="https://cdn.magicpatterns.com/uploads/duuryXCWRM5JCcsMaKzXxu/image.png" controls={isVideoPlaying} playsInline preload="metadata" style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }} data-id="element-272" />
            {!isVideoPlaying && <Flex position="absolute" top={0} left={0} right={0} bottom={0} align="center" justify="center" bg="rgba(0, 0, 0, 0.4)" cursor="pointer" onClick={handlePlayVideo} zIndex={2} transition="background 0.3s" _hover={{
            bg: 'rgba(0, 0, 0, 0.25)'
          }} data-id="element-273">
                {/* YouTube-style play button */}
                <Box as="svg" viewBox="0 0 68 48" w={{
              base: '68px',
              md: '90px'
            }} h={{
              base: '48px',
              md: '63px'
            }} sx={{
              '& .ytp-bg': {
                fill: '#212121',
                fillOpacity: 0.8,
                transition: 'fill 0.1s, fill-opacity 0.1s'
              },
              '&:hover .ytp-bg': {
                fill: '#f00',
                fillOpacity: 1
              }
            }} data-id="element-274">
                  <path className="ytp-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" data-id="element-275" />
                  <path fill="#fff" d="M 45,24 27,14 27,34" data-id="element-276" />
                </Box>
              </Flex>}
          </Box>

          {/* Estadística resumida debajo del video */}
          <Flex align="center" justify="center" gap={3} bg="rgba(255, 215, 0, 0.06)" border="1px solid rgba(255, 215, 0, 0.15)" borderRadius="xl" px={5} py={3} data-id="element-277">
            <Text fontSize="2xl" fontWeight="black" color="#ffd700" data-id="element-278">
              91%
            </Text>
            <Text fontSize="xs" color="whiteAlpha.700" lineHeight="1.4" data-id="element-279">
              reportaron resultados en 5-7 días: oportunidades laborales, golpes
              de suerte, negocios generando miles y cero ansiedad financiera.
            </Text>
          </Flex>

          {/* 3. CTA #1 */}
          <Box textAlign="center" pt={0} data-id="element-280">
            <CTAButton text="QUIERO ACTIVAR MI ABUNDANCIA AHORA" href={checkoutUrl} onClick={handleCheckoutClick} data-id="element-281" />
            <Text fontSize="sm" color="whiteAlpha.500" mt={3} letterSpacing="wide" data-id="element-282">
              (Acceso inmediato por solo $28.88 USD)
            </Text>
            <Flex align="center" justify="center" gap={2} mt={4} data-id="element-283">
              <Icon as={ShieldCheckIcon} boxSize={4} color="whiteAlpha.500" data-id="element-284" />
              <Text fontSize="xs" color="whiteAlpha.500" data-id="element-285">
                Si no te convence, te devolvemos tu dinero. Sin preguntas.
              </Text>
            </Flex>
          </Box>

          {/* 4. PROBLEMA */}
          <Box position="relative" pl={{
          base: 6,
          md: 10
        }} py={{
          base: 8,
          md: 12
        }} data-id="element-286">
            {/* Thick vertical gold bar */}
            <Box position="absolute" left={0} top={0} bottom={0} w={{
            base: '4px',
            md: '8px'
          }} bgGradient="linear(to-b, #ffd700, transparent)" borderRadius="full" data-id="element-287" />

            <Text fontSize="xl" mb={10} color="whiteAlpha.800" fontStyle="italic" textAlign="left" data-id="element-288">
              Si estás aquí, probablemente te ha pasado esto:
            </Text>

            <VStack spacing={5} align="stretch" mb={8} data-id="element-289">
              <Box bg="rgba(255, 255, 255, 0.02)" p={5} borderRadius="lg" borderLeft="4px solid" borderColor="red.400" w={{
              base: '100%',
              md: '85%'
            }} alignSelf="flex-start" boxShadow="0 10px 30px -10px rgba(0,0,0,0.5)" data-id="element-290">
                <Flex align="center" gap={4} data-id="element-291">
                  <Text color="red.400" fontSize="2xl" fontWeight="black" opacity={0.5} data-id="element-292">
                    01
                  </Text>
                  <Text fontSize="lg" color="whiteAlpha.900" data-id="element-293">
                    Haces rituales… pero el dinero no llega
                  </Text>
                </Flex>
              </Box>

              <Box bg="rgba(255, 255, 255, 0.02)" p={5} borderRadius="lg" borderLeft="4px solid" borderColor="red.400" w={{
              base: '100%',
              md: '85%'
            }} alignSelf={{
              base: 'flex-start',
              md: 'center'
            }} transform={{
              md: 'translateX(5%)'
            }} boxShadow="0 10px 30px -10px rgba(0,0,0,0.5)" data-id="element-294">
                <Flex align="center" gap={4} data-id="element-295">
                  <Text color="red.400" fontSize="2xl" fontWeight="black" opacity={0.5} data-id="element-296">
                    02
                  </Text>
                  <Text fontSize="lg" color="whiteAlpha.900" data-id="element-297">
                    Repites afirmaciones… pero todo sigue igual
                  </Text>
                </Flex>
              </Box>

              <Box bg="rgba(255, 255, 255, 0.02)" p={5} borderRadius="lg" borderLeft="4px solid" borderColor="red.400" w={{
              base: '100%',
              md: '85%'
            }} alignSelf={{
              base: 'flex-start',
              md: 'flex-end'
            }} boxShadow="0 10px 30px -10px rgba(0,0,0,0.5)" data-id="element-298">
                <Flex align="center" gap={4} data-id="element-299">
                  <Text color="red.400" fontSize="2xl" fontWeight="black" opacity={0.5} data-id="element-300">
                    03
                  </Text>
                  <Text fontSize="lg" color="whiteAlpha.900" data-id="element-301">
                    Sientes que el universo te ignora
                  </Text>
                </Flex>
              </Box>
            </VStack>

            <Box textAlign="right" mt={8} data-id="element-302">
              <Text fontSize="xl" mb={2} color="whiteAlpha.700" fontStyle="italic" data-id="element-303">
                Y lo peor…
              </Text>
              <Text fontSize="2xl" fontWeight="bold" color="#ffd700" fontFamily="'Playfair Display', Georgia, serif" mb={6} data-id="element-304">
                Empiezas a pensar que el problema eres tú.
              </Text>
              <Text fontSize={{
              base: '5xl',
              md: '7xl'
            }} fontWeight="black" color="white" lineHeight="1" textShadow="0 10px 30px rgba(0,0,0,0.5)" letterSpacing="tighter" data-id="element-305">
                Pero no lo eres.
              </Text>
            </Box>
          </Box>

          {/* 5. REVELACIÓN */}
          <Box position="relative" mt={4} mb={4} data-id="element-306">
            <Flex direction={{
            base: 'column',
            md: 'row'
          }} gap={8} align="center" data-id="element-307">
              <Box flexShrink={0} display={{
              base: 'none',
              md: 'block'
            }} opacity={0.1} data-id="element-308">
                <Text fontSize="180px" fontWeight="black" color="#ffd700" lineHeight="0.8" fontFamily="'Playfair Display', Georgia, serif" data-id="element-309">
                  ?
                </Text>
              </Box>

              <Box flex="1" textAlign="left" data-id="element-310">
                <Heading as="h2" size="xl" mb={6} color="whiteAlpha.600" fontFamily="'Inter', sans-serif" fontWeight="light" textTransform="uppercase" letterSpacing="widest" fontSize="sm" data-id="element-311">
                  La verdad es esta:
                </Heading>

                <Text fontSize={{
                base: '2xl',
                md: '3xl'
              }} mb={8} lineHeight="1.4" fontWeight="light" data-id="element-312">
                  Tu capacidad de atraer dinero no está dañada… Lo que está
                  bloqueado es tu
                </Text>

                <Box position="relative" display="inline-block" mb={6} data-id="element-313">
                  <Box position="absolute" bottom="10%" left="-5%" right="-5%" height="40%" bg="#ffd700" opacity={0.3} transform="rotate(-2deg)" zIndex={0} data-id="element-314" />
                  <Text as="span" position="relative" zIndex={1} fontSize={{
                  base: '4xl',
                  md: '5xl'
                }} fontWeight="black" color="white" fontFamily="'Playfair Display', Georgia, serif" fontStyle="italic" data-id="element-315">
                    "canal de recepción"
                  </Text>
                </Box>

                <Text fontSize="lg" mb={6} color="whiteAlpha.600" fontStyle="italic" borderLeft="2px solid rgba(255,255,255,0.2)" pl={4} data-id="element-316">
                  Después de años intentando desde la desesperación…
                </Text>
                <Text fontSize="2xl" mb={8} fontWeight="medium" color="whiteAlpha.900" data-id="element-317">
                  Tu mente asocia el dinero con estrés.
                </Text>
              </Box>
            </Flex>

            <Box position="relative" bg="rgba(245, 101, 101, 0.05)" border="1px solid rgba(245, 101, 101, 0.2)" p={6} mt={4} overflow="hidden" _before={{
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '4px',
            background: 'repeating-linear-gradient(45deg, #fc8181, #fc8181 10px, transparent 10px, transparent 20px)'
          }} data-id="element-318">
              <Text fontSize="xl" color="red.300" fontWeight="medium" textAlign="center" data-id="element-319">
                Y eso hace que bloquees la abundancia… sin darte cuenta.
              </Text>
            </Box>
          </Box>

          {/* 6. CTA #2 */}
          <Box textAlign="center" pt={4} data-id="element-320">
            <CTAButton text="SÍ, QUIERO DESBLOQUEAR MI ABUNDANCIA" href={checkoutUrl} onClick={handleCheckoutClick} data-id="element-321" />
          </Box>

          {/* 7. DESCUBRIMIENTO */}
          <Box position="relative" mt={6} mb={4} p={{
          base: 6,
          md: 12
        }} data-id="element-322">
            {/* Massive watermark */}
            <Text position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" fontSize={{
            base: '200px',
            md: '350px'
          }} fontWeight="black" color="#ffd700" opacity={0.03} zIndex={0} pointerEvents="none" fontFamily="'Playfair Display', Georgia, serif" data-id="element-323">
              888
            </Text>

            <Box position="relative" zIndex={1} bg="rgba(15, 23, 42, 0.6)" backdropFilter="blur(5px)" border="2px dashed rgba(255, 215, 0, 0.3)" p={{
            base: 8,
            md: 12
          }} transform="rotate(-1deg)" boxShadow="20px 20px 60px rgba(0,0,0,0.5)" data-id="element-324">
              {/* Stamp */}
              <Box position="absolute" top={{
              base: -4,
              md: -6
            }} right={{
              base: 4,
              md: 8
            }} border="2px solid #ffd700" color="#ffd700" px={4} py={1} transform="rotate(5deg)" fontWeight="black" letterSpacing="widest" fontSize={{
              base: 'xs',
              md: 'sm'
            }} bg="#0f172a" data-id="element-325">
                CONFIDENCIAL
              </Box>

              <Box transform="rotate(1deg)" data-id="element-326">
                <Text fontSize="sm" mb={6} color="whiteAlpha.600" textTransform="uppercase" letterSpacing="widest" borderBottom="1px solid rgba(255,255,255,0.1)" pb={2} display="inline-block" data-id="element-327">
                  Un grupo de investigadores descubrió algo impactante:
                </Text>

                <Heading as="h3" size="2xl" mb={8} color="#ffd700" fontFamily="'Playfair Display', Georgia, serif" lineHeight="1.2" data-id="element-328">
                  Un código ancestral llamado 888…
                </Heading>

                <Text fontSize="xl" mb={10} color="whiteAlpha.900" fontWeight="light" lineHeight="1.8" data-id="element-329">
                  Presente en culturas que entendían la riqueza de forma
                  diferente.
                </Text>

                <Box borderLeft="3px solid red" pl={4} data-id="element-330">
                  <Text fontSize="xl" fontWeight="bold" color="white" mb={2} data-id="element-331">
                    Pero había un problema…
                  </Text>
                  <Text fontSize="xl" color="red.300" fontStyle="italic" data-id="element-332">
                    La mayoría lo usa mal.
                  </Text>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* 8. ERROR */}
          <Flex direction={{
          base: 'column',
          md: 'row'
        }} align="center" bgGradient="linear(to-r, rgba(245, 101, 101, 0.05), transparent)" borderRadius="2xl" overflow="hidden" position="relative" mb={4} data-id="element-333">
            <Box w={{
            base: '100%',
            md: '30%'
          }} display="flex" justifyContent="center" alignItems="center" py={{
            base: 6,
            md: 0
          }} data-id="element-334">
              <Icon as={CheckCircleIcon} color="red.500" boxSize={{
              base: 24,
              md: 32
            }} opacity={0.2} data-id="element-335" />
            </Box>

            <Box w={{
            base: '100%',
            md: '70%'
          }} p={{
            base: 8,
            md: 12
          }} pl={{
            md: 0
          }} data-id="element-336">
              <Text fontSize="2xl" mb={4} color="whiteAlpha.800" fontWeight="light" data-id="element-337">
                Puedes hacer el ritual perfecto…
              </Text>
              <Text fontSize="2xl" mb={8} color="whiteAlpha.800" fontWeight="light" data-id="element-338">
                Pero si lo haces desde el miedo…
              </Text>

              <Box data-id="element-339">
                <Heading as="h3" fontSize={{
                base: '3xl',
                md: '5xl'
              }} color="red.400" fontFamily="'Playfair Display', Georgia, serif" lineHeight="1.1" data-id="element-340">
                  <Text as="span" display="block" mb={2} data-id="element-341">
                    Tu mente
                  </Text>
                  <Text as="span" display="block" mb={2} data-id="element-342">
                    lo bloquea
                  </Text>
                  <Text as="span" display="block" data-id="element-343">
                    automáticamente.
                  </Text>
                </Heading>
              </Box>
            </Box>
          </Flex>

          {/* 9. SOLUCIÓN */}
          <Box position="relative" pt={6} pb={6} data-id="element-344">
            {/* Expanding line reveal effect */}
            <Box w="100%" h="1px" bgGradient="linear(to-r, transparent, #ffd700, transparent)" mb={8} opacity={0.5} data-id="element-345" />

            <Box textAlign={{
            base: 'center',
            md: 'left'
          }} data-id="element-346">
              <Heading as="h2" fontSize={{
              base: '3xl',
              md: '4xl'
            }} mb={8} color="#ffd700" fontFamily="'Playfair Display', Georgia, serif" fontStyle="italic" letterSpacing="wide" data-id="element-347">
                Aquí es donde todo cambia:
              </Heading>

              <Text fontSize="xl" mb={8} color="whiteAlpha.900" fontWeight="light" lineHeight="1.8" data-id="element-348">
                Los investigadores encontraron que usando una frecuencia
                específica…
              </Text>

              <Text fontSize="2xl" mb={6} color="whiteAlpha.900" fontWeight="light" data-id="element-349">
                Puedes crear primero el estado correcto…
              </Text>

              <Box display="inline-block" position="relative" data-id="element-350">
                <Text fontSize={{
                base: '3xl',
                md: '4xl'
              }} fontWeight="black" color="#ffd700" fontFamily="'Playfair Display', Georgia, serif" position="relative" zIndex={1} data-id="element-351">
                  Y luego activar la abundancia.
                </Text>
                {/* Subtle animated underline effect */}
                <Box position="absolute" bottom="4px" left="0" w="100%" h="3px" bg="#ffd700" opacity={0.5} borderRadius="full" data-id="element-352" />
              </Box>
            </Box>
          </Box>

          {/* 10. CTA #3 */}
          <Box textAlign="center" data-id="element-353">
            <CTAButton text="ACTIVAR PROTOCOLO 888 AHORA" href={checkoutUrl} onClick={handleCheckoutClick} data-id="element-354" />
          </Box>

          {/* 11. RESULTADOS */}
          <Box textAlign="center" px={{
          base: 4,
          md: 8
        }} data-id="element-355">
            {/* Estadística destacada */}
            <Box bg="rgba(255, 215, 0, 0.08)" border="2px solid rgba(255, 215, 0, 0.3)" borderRadius="2xl" p={{
            base: 6,
            md: 10
          }} mb={10} data-id="element-356">
              <Text fontSize={{
              base: '5xl',
              md: '7xl'
            }} fontWeight="black" color="#ffd700" lineHeight="1" mb={4} data-id="element-357">
                91%
              </Text>
              <Text fontSize={{
              base: 'lg',
              md: 'xl'
            }} color="whiteAlpha.900" fontWeight="medium" lineHeight="1.6" data-id="element-358">
                de las personas que activaron el Protocolo 888 reportaron
                resultados visibles entre los{' '}
                <Text as="span" color="#ffd700" fontWeight="bold" data-id="element-359">
                  5 y 7 días.
                </Text>
              </Text>
            </Box>

            <Heading as="h3" size="xl" mb={10} fontFamily="'Playfair Display', Georgia, serif" color="white" data-id="element-360">
              Esto es lo que empezaron a vivir:
            </Heading>
            <VStack spacing={6} align="center" mb={12} data-id="element-361">
              <Flex align="center" gap={4} bg="rgba(255,255,255,0.03)" p={4} px={6} borderRadius="full" border="1px solid rgba(255,255,255,0.05)" data-id="element-362">
                <Text fontSize="xl" data-id="element-363">💼</Text>
                <Text fontSize="lg" color="whiteAlpha.900" data-id="element-364">
                  Ofertas de trabajo y oportunidades laborales inesperadas
                </Text>
              </Flex>
              <Flex align="center" gap={4} bg="rgba(255,255,255,0.03)" p={4} px={6} borderRadius="full" border="1px solid rgba(255,255,255,0.05)" data-id="element-365">
                <Text fontSize="xl" data-id="element-366">🎰</Text>
                <Text fontSize="lg" color="whiteAlpha.900" data-id="element-367">
                  Golpes de suerte que no se explican con lógica
                </Text>
              </Flex>
              <Flex align="center" gap={4} bg="rgba(255,255,255,0.03)" p={4} px={6} borderRadius="full" border="1px solid rgba(255,255,255,0.05)" data-id="element-368">
                <Text fontSize="xl" data-id="element-369">📈</Text>
                <Text fontSize="lg" color="whiteAlpha.900" data-id="element-370">
                  Negocios que empezaron a generar miles de dólares
                </Text>
              </Flex>
              <Flex align="center" gap={4} bg="rgba(255,255,255,0.03)" p={4} px={6} borderRadius="full" border="1px solid rgba(255,255,255,0.05)" data-id="element-371">
                <Text fontSize="xl" data-id="element-372">🧘</Text>
                <Text fontSize="lg" color="whiteAlpha.900" data-id="element-373">
                  Desapareció la ansiedad financiera por completo
                </Text>
              </Flex>
            </VStack>
            <Text fontSize="2xl" mb={4} color="whiteAlpha.700" fontWeight="light" data-id="element-374">
              Dejaron de perseguir el dinero…
            </Text>
            <Text fontSize="4xl" fontWeight="bold" color="#ffd700" fontFamily="'Playfair Display', Georgia, serif" data-id="element-375">
              Y empezó a llegar.
            </Text>
          </Box>

          {/* TESTIMONIOS */}
          <Box data-id="element-376">
            <Heading as="h3" size="xl" mb={8} textAlign="center" fontFamily="'Playfair Display', Georgia, serif" color="white" data-id="element-377">
              Lo que dicen quienes ya lo activaron:
            </Heading>
            <VStack spacing={6} data-id="element-378">
              {/* Testimonio 1 */}
              <Box bg="rgba(255, 255, 255, 0.03)" border="1px solid rgba(255, 215, 0, 0.15)" borderRadius="2xl" p={{
              base: 6,
              md: 8
            }} position="relative" data-id="element-379">
                <Text fontSize="2xl" color="#ffd700" position="absolute" top={4} left={6} opacity={0.3} fontFamily="Georgia, serif" data-id="element-380">
                  "
                </Text>
                <Flex direction={{
                base: 'column',
                md: 'row'
              }} align={{
                base: 'center',
                md: 'flex-start'
              }} gap={5} data-id="element-381">
                  <Image src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&h=80&fit=crop&crop=face&q=75&fm=webp" alt="María Elena" loading="lazy" borderRadius="full" w="70px" h="70px" objectFit="cover" border="2px solid rgba(255, 215, 0, 0.4)" flexShrink={0} data-id="element-382" />
                  <Box data-id="element-383">
                    <Text fontSize="md" color="whiteAlpha.900" mb={3} lineHeight="1.7" fontStyle="italic" data-id="element-384">
                      "Llevaba meses haciendo afirmaciones y nada cambiaba. A
                      los 4 días de escuchar el audio 888, me llamaron para un
                      trabajo freelance que me pagó $1,200 dólares. No lo podía
                      creer. Algo se desbloqueó en mí."
                    </Text>
                    <Flex align="center" gap={2} data-id="element-385">
                      <Text fontWeight="bold" color="white" fontSize="sm" data-id="element-386">
                        María Elena R.
                      </Text>
                      <Text color="whiteAlpha.500" fontSize="xs" data-id="element-387">
                        •
                      </Text>
                      <Text color="whiteAlpha.500" fontSize="xs" data-id="element-388">
                        Guadalajara, México
                      </Text>
                    </Flex>
                    <Flex mt={1} gap={0.5} data-id="element-389">
                      {[1, 2, 3, 4, 5].map(i => <Text key={i} color="#ffd700" fontSize="xs" data-id="element-390">
                          ★
                        </Text>)}
                    </Flex>
                  </Box>
                </Flex>
              </Box>

              {/* Testimonio 2 */}
              <Box bg="rgba(255, 255, 255, 0.03)" border="1px solid rgba(255, 215, 0, 0.15)" borderRadius="2xl" p={{
              base: 6,
              md: 8
            }} position="relative" data-id="element-391">
                <Text fontSize="2xl" color="#ffd700" position="absolute" top={4} left={6} opacity={0.3} fontFamily="Georgia, serif" data-id="element-392">
                  "
                </Text>
                <Flex direction={{
                base: 'column',
                md: 'row'
              }} align={{
                base: 'center',
                md: 'flex-start'
              }} gap={5} data-id="element-393">
                  <Image src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face&q=75&fm=webp" alt="Carlos Andrés" loading="lazy" borderRadius="full" w="70px" h="70px" objectFit="cover" border="2px solid rgba(255, 215, 0, 0.4)" flexShrink={0} data-id="element-394" />
                  <Box data-id="element-395">
                    <Text fontSize="md" color="whiteAlpha.900" mb={3} lineHeight="1.7" fontStyle="italic" data-id="element-396">
                      "Yo era escéptico, lo admito. Pero mi esposa insistió y lo
                      probamos juntos. En la primera semana nos devolvieron un
                      dinero que dábamos por perdido hace 2 años. Coincidencia o
                      no… seguimos escuchándolo cada noche."
                    </Text>
                    <Flex align="center" gap={2} data-id="element-397">
                      <Text fontWeight="bold" color="white" fontSize="sm" data-id="element-398">
                        Carlos Andrés M.
                      </Text>
                      <Text color="whiteAlpha.500" fontSize="xs" data-id="element-399">
                        •
                      </Text>
                      <Text color="whiteAlpha.500" fontSize="xs" data-id="element-400">
                        Monterrey, México
                      </Text>
                    </Flex>
                    <Flex mt={1} gap={0.5} data-id="element-401">
                      {[1, 2, 3, 4, 5].map(i => <Text key={i} color="#ffd700" fontSize="xs" data-id="element-402">
                          ★
                        </Text>)}
                    </Flex>
                  </Box>
                </Flex>
              </Box>

              {/* Testimonio 3 */}
              <Box bg="rgba(255, 255, 255, 0.03)" border="1px solid rgba(255, 215, 0, 0.15)" borderRadius="2xl" p={{
              base: 6,
              md: 8
            }} position="relative" data-id="element-403">
                <Text fontSize="2xl" color="#ffd700" position="absolute" top={4} left={6} opacity={0.3} fontFamily="Georgia, serif" data-id="element-404">
                  "
                </Text>
                <Flex direction={{
                base: 'column',
                md: 'row'
              }} align={{
                base: 'center',
                md: 'flex-start'
              }} gap={5} data-id="element-405">
                  <Image src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face&q=75&fm=webp" alt="Lucía Fernanda" loading="lazy" borderRadius="full" w="70px" h="70px" objectFit="cover" border="2px solid rgba(255, 215, 0, 0.4)" flexShrink={0} data-id="element-406" />
                  <Box data-id="element-407">
                    <Text fontSize="md" color="whiteAlpha.900" mb={3} lineHeight="1.7" fontStyle="italic" data-id="element-408">
                      "Tenía deudas y mucha ansiedad. Empecé el protocolo sin
                      esperar mucho. Al día 5 me ofrecieron un aumento en el
                      trabajo y una clienta me pagó por adelantado. Siento que
                      la energía alrededor del dinero cambió por completo."
                    </Text>
                    <Flex align="center" gap={2} data-id="element-409">
                      <Text fontWeight="bold" color="white" fontSize="sm" data-id="element-410">
                        Lucía Fernanda P.
                      </Text>
                      <Text color="whiteAlpha.500" fontSize="xs" data-id="element-411">
                        •
                      </Text>
                      <Text color="whiteAlpha.500" fontSize="xs" data-id="element-412">
                        Ciudad de México, México
                      </Text>
                    </Flex>
                    <Flex mt={1} gap={0.5} data-id="element-413">
                      {[1, 2, 3, 4, 5].map(i => <Text key={i} color="#ffd700" fontSize="xs" data-id="element-414">
                          ★
                        </Text>)}
                    </Flex>
                  </Box>
                </Flex>
              </Box>
            </VStack>
          </Box>

          {/* 12. PRODUCTO & 13. CÓMO FUNCIONA */}
          <Box textAlign="center" bg="rgba(255, 255, 255, 0.02)" p={{
          base: 8,
          md: 12
        }} borderRadius="3xl" border="1px solid rgba(255, 215, 0, 0.15)" boxShadow="0 10px 30px rgba(0,0,0,0.5)" data-id="element-415">
            <Heading as="h2" size="2xl" mb={6} color="#ffd700" fontFamily="'Playfair Display', Georgia, serif" data-id="element-416">
              Protocolo Frecuencia 888
            </Heading>
            <Text fontSize="xl" mb={8} color="whiteAlpha.800" fontWeight="light" data-id="element-417">
              Sistema diseñado para activar tu abundancia desde el primer día.
            </Text>

            {/* Product Video */}
            <Box w="100%" maxW="350px" mx="auto" position="relative" borderRadius="2xl" overflow="hidden" border="2px solid rgba(255, 215, 0, 0.4)" boxShadow="0 0 40px rgba(255,215,0,0.2)" mb={10} sx={{
            aspectRatio: '1 / 1'
          }} data-id="element-418">
              <video src="https://cdn.magicpatterns.com/uploads/rnszQfVhKY9FGkiRm9hAwa/sora-video-c126ec3b-0654-467b-b168-7f38b70ec754_.mp4" autoPlay loop muted playsInline preload="none" style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }} data-id="element-419" />
              <Box position="absolute" bottom={0} left={0} right={0} h="30%" bgGradient="linear(to-t, rgba(15,23,42,0.9) 0%, transparent 100%)" pointerEvents="none" data-id="element-420" />
            </Box>

            <Heading as="h4" size="sm" mb={8} color="whiteAlpha.500" textTransform="uppercase" letterSpacing="widest" data-id="element-421">
              CÓMO FUNCIONA
            </Heading>
            <Flex direction={{
            base: 'column',
            md: 'row'
          }} justify="center" gap={8} align="center" data-id="element-422">
              <VStack data-id="element-423">
                <Box bg="rgba(255,215,0,0.1)" w="50px" h="50px" borderRadius="full" display="flex" alignItems="center" justifyContent="center" border="1px solid rgba(255,215,0,0.3)" color="#ffd700" fontWeight="bold" fontSize="xl" data-id="element-424">
                  1
                </Box>
                <Text fontSize="lg" color="whiteAlpha.900" data-id="element-425">
                  Activas el protocolo
                </Text>
              </VStack>
              <Box w={{
              base: '2px',
              md: '50px'
            }} h={{
              base: '30px',
              md: '2px'
            }} bg="rgba(255,255,255,0.1)" data-id="element-426" />
              <VStack data-id="element-427">
                <Box bg="rgba(255,215,0,0.1)" w="50px" h="50px" borderRadius="full" display="flex" alignItems="center" justifyContent="center" border="1px solid rgba(255,215,0,0.3)" color="#ffd700" fontWeight="bold" fontSize="xl" data-id="element-428">
                  2
                </Box>
                <Text fontSize="lg" color="whiteAlpha.900" data-id="element-429">
                  Escuchas el audio
                </Text>
              </VStack>
              <Box w={{
              base: '2px',
              md: '50px'
            }} h={{
              base: '30px',
              md: '2px'
            }} bg="rgba(255,255,255,0.1)" data-id="element-430" />
              <VStack data-id="element-431">
                <Box bg="rgba(255,215,0,0.2)" w="60px" h="60px" borderRadius="full" display="flex" alignItems="center" justifyContent="center" border="2px solid #ffd700" color="#ffd700" fontWeight="bold" fontSize="2xl" boxShadow="0 0 15px rgba(255,215,0,0.3)" data-id="element-432">
                  3
                </Box>
                <Text fontSize="lg" fontWeight="bold" color="#ffd700" data-id="element-433">
                  Empiezas a notar cambios
                </Text>
              </VStack>
            </Flex>
          </Box>

          {/* 14. LO QUE RECIBES */}
          <Box data-id="element-434">
            <Box bg="rgba(15, 23, 42, 0.8)" border="1px solid rgba(255, 215, 0, 0.4)" borderRadius="xl" overflow="hidden" mb={12} maxW="450px" mx="auto" boxShadow="0 10px 30px rgba(0,0,0,0.5), inset 0 0 20px rgba(255,215,0,0.05)" data-id="element-435">
              <Table variant="simple" size="md" data-id="element-436">
                <Tbody data-id="element-437">
                  <Tr bg="rgba(255, 215, 0, 0.15)" data-id="element-438">
                    <Td fontWeight="bold" fontSize="sm" py={4} color="#ffd700" textTransform="uppercase" letterSpacing="wider" data-id="element-439">
                      Lo que recibes
                    </Td>
                    <Td fontWeight="bold" fontSize="sm" py={4} isNumeric color="#ffd700" textTransform="uppercase" letterSpacing="wider" data-id="element-440">
                      Valor
                    </Td>
                  </Tr>
                  <Tr borderBottom="1px solid rgba(255,255,255,0.05)" data-id="element-441">
                    <Td fontSize="sm" py={3} color="whiteAlpha.900" data-id="element-442">
                      <Text as="span" color="#ffd700" mr={2} data-id="element-443">
                        ✓
                      </Text>{' '}
                      Manual Maestro del Ritual 888 (PDF)
                    </Td>
                    <Td fontSize="sm" py={3} isNumeric color="whiteAlpha.600" data-id="element-444">
                      $97
                    </Td>
                  </Tr>
                  <Tr borderBottom="1px solid rgba(255,255,255,0.05)" data-id="element-445">
                    <Td fontSize="sm" py={3} color="whiteAlpha.900" data-id="element-446">
                      <Text as="span" color="#ffd700" mr={2} data-id="element-447">
                        ✓
                      </Text>{' '}
                      Audio de Activación 888Hz (MP3)
                    </Td>
                    <Td fontSize="sm" py={3} isNumeric color="whiteAlpha.600" data-id="element-448">
                      $67
                    </Td>
                  </Tr>
                  <Tr borderBottom="1px solid rgba(255,255,255,0.05)" data-id="element-449">
                    <Td fontSize="sm" py={3} color="whiteAlpha.900" data-id="element-450">
                      <Text as="span" color="#ffd700" mr={2} data-id="element-451">
                        ✓
                      </Text>{' '}
                      Diario de Sincronías (PDF)
                    </Td>
                    <Td fontSize="sm" py={3} isNumeric color="whiteAlpha.600" data-id="element-452">
                      $37
                    </Td>
                  </Tr>
                  <Tr borderBottom="1px solid rgba(255,255,255,0.05)" data-id="element-453">
                    <Td fontSize="sm" py={3} color="whiteAlpha.900" data-id="element-454">
                      <Text as="span" color="#ffd700" mr={2} data-id="element-455">
                        ✓
                      </Text>{' '}
                      Diccionario Palabras Prohibidas (PDF)
                    </Td>
                    <Td fontSize="sm" py={3} isNumeric color="whiteAlpha.600" data-id="element-456">
                      $27
                    </Td>
                  </Tr>
                  <Tr borderBottom="1px solid rgba(255,255,255,0.05)" data-id="element-457">
                    <Td fontSize="sm" py={3} color="whiteAlpha.900" data-id="element-458">
                      <Text as="span" color="#ffd700" mr={2} data-id="element-459">
                        ✓
                      </Text>{' '}
                      Certificado CICPA (PDF)
                    </Td>
                    <Td fontSize="sm" py={3} isNumeric color="whiteAlpha.600" data-id="element-460">
                      $19
                    </Td>
                  </Tr>
                  <Tr bg="rgba(255, 255, 255, 0.02)" data-id="element-461">
                    <Td fontSize="md" py={4} color="whiteAlpha.700" fontWeight="medium" data-id="element-462">
                      Valor total real
                    </Td>
                    <Td fontSize="md" py={4} isNumeric textDecoration="line-through" color="red.400" data-id="element-463">
                      $247 USD
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>

            {/* 15. REGALOS */}
            <Box textAlign="center" mb={8} data-id="element-464">
              <Text fontSize="lg" fontWeight="bold" color="#ffd700" fontFamily="'Playfair Display', Georgia, serif" data-id="element-465">
                Si compras el Protocolo 888 hoy, recibes estos 2 regalos:
              </Text>
              <Text fontSize="sm" color="whiteAlpha.500" mt={2} fontStyle="italic" data-id="element-466">
                ⏰ Válido solo hasta el{' '}
                {new Date().toLocaleDateString('es-MX', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              })}
              </Text>
            </Box>

            <Box border="1px solid rgba(255, 215, 0, 0.3)" bg="rgba(255, 215, 0, 0.03)" p={{
            base: 6,
            md: 8
          }} borderRadius="2xl" mb={6} position="relative" overflow="hidden" data-id="element-467">
              <Box position="absolute" top={0} left={0} w="4px" h="100%" bg="#ffd700" data-id="element-468" />
              <Flex direction={{
              base: 'column',
              md: 'row'
            }} align="center" gap={6} data-id="element-469">
                <Image src="https://cdn.magicpatterns.com/uploads/2YNmMyJkQYZxLWPSNutJ2i/1_regalo.png" alt="Audio Reset 888" loading="lazy" w={{
                base: '160px',
                md: '140px'
              }} borderRadius="lg" boxShadow="0 10px 20px rgba(0,0,0,0.5)" data-id="element-470" />
                <Box flex="1" textAlign={{
                base: 'center',
                md: 'left'
              }} data-id="element-471">
                  <Text color="#ffd700" fontWeight="bold" fontSize="xs" letterSpacing="widest" mb={2} textTransform="uppercase" data-id="element-472">
                    REGALO #1
                  </Text>
                  <Heading as="h3" size="md" mb={3} fontFamily="'Playfair Display', Georgia, serif" color="white" data-id="element-473">
                    Audio Reset 888
                  </Heading>
                  <Text fontSize="sm" mb={3} color="whiteAlpha.800" lineHeight="1.6" data-id="element-474">
                    Un audio de 3 minutos diseñado para borrar bloqueos
                    subconscientes sobre el dinero antes de dormir. Escúchalo y
                    despierta con una mentalidad magnética.
                  </Text>
                  <Text fontWeight="medium" color="whiteAlpha.900" fontSize="sm" data-id="element-475">
                    Valorado en{' '}
                    <Text as="span" textDecoration="line-through" color="whiteAlpha.500" mr={1} data-id="element-476">
                      $47 USD
                    </Text>{' '}
                    -{' '}
                    <Text as="span" color="#ffd700" fontWeight="bold" data-id="element-477">
                      HOY GRATIS
                    </Text>
                  </Text>
                </Box>
              </Flex>
            </Box>

            <Box border="1px solid rgba(255, 215, 0, 0.3)" bg="rgba(255, 215, 0, 0.03)" p={{
            base: 6,
            md: 8
          }} borderRadius="2xl" mb={8} position="relative" overflow="hidden" data-id="element-478">
              <Box position="absolute" top={0} left={0} w="4px" h="100%" bg="#ffd700" data-id="element-479" />
              <Flex direction={{
              base: 'column',
              md: 'row'
            }} align="center" gap={6} data-id="element-480">
                <Image src="https://cdn.magicpatterns.com/uploads/634LcXA2r2HZYSjbDxMSd4/regalo_2.png" alt="Audio Candado 888" loading="lazy" w={{
                base: '160px',
                md: '140px'
              }} borderRadius="lg" boxShadow="0 10px 20px rgba(0,0,0,0.5)" data-id="element-481" />
                <Box flex="1" textAlign={{
                base: 'center',
                md: 'left'
              }} data-id="element-482">
                  <Text color="#ffd700" fontWeight="bold" fontSize="xs" letterSpacing="widest" mb={2} textTransform="uppercase" data-id="element-483">
                    REGALO #2
                  </Text>
                  <Heading as="h3" size="md" mb={3} fontFamily="'Playfair Display', Georgia, serif" color="white" data-id="element-484">
                    Audio Candado 888
                  </Heading>
                  <Text fontSize="sm" mb={3} color="whiteAlpha.800" lineHeight="1.6" data-id="element-485">
                    Frecuencia protectora de 5 minutos. Crea un "escudo
                    energético" alrededor de tus finanzas para que el dinero que
                    llegue, se quede y se multiplique.
                  </Text>
                  <Text fontWeight="medium" color="whiteAlpha.900" fontSize="sm" data-id="element-486">
                    Valorado en{' '}
                    <Text as="span" textDecoration="line-through" color="whiteAlpha.500" mr={1} data-id="element-487">
                      $55 USD
                    </Text>{' '}
                    -{' '}
                    <Text as="span" color="#ffd700" fontWeight="bold" data-id="element-488">
                      HOY GRATIS
                    </Text>
                  </Text>
                </Box>
              </Flex>
            </Box>
          </Box>

          {/* 16. PRECIO */}
          <Box textAlign="center" pt={4} data-id="element-489">
            <Text fontSize="xl" textDecoration="line-through" color="whiteAlpha.500" mb={4} data-id="element-490">
              Valor real: $247 USD
            </Text>
            <Heading as="h2" fontSize={{
            base: '6xl',
            md: '8xl'
          }} fontWeight="black" color="white" textShadow="0 0 30px rgba(255, 215, 0, 0.4)" mb={10} letterSpacing="tighter" data-id="element-491">
              👉 HOY: $28.88 USD
            </Heading>
          </Box>

          {/* 17. CTA #4 */}
          <Box textAlign="center" data-id="element-492">
            <CTAButton text="APROVECHAR OFERTA DE $28.88 AHORA" href={checkoutUrl} onClick={handleCheckoutClick} data-id="element-493" />
          </Box>

          {/* 18. GARANTÍA */}
          <Flex align="center" justify="center" gap={5} bg="rgba(255, 255, 255, 0.03)" border="1px solid rgba(255, 255, 255, 0.1)" borderRadius="2xl" p={8} maxW="550px" mx="auto" boxShadow="0 10px 30px rgba(0,0,0,0.2)" data-id="element-494">
            <Icon as={ShieldCheckIcon} boxSize={12} color="#ffd700" flexShrink={0} data-id="element-495" />
            <Box textAlign="left" data-id="element-496">
              <Text fontSize="xl" fontWeight="bold" color="white" mb={2} fontFamily="'Playfair Display', Georgia, serif" data-id="element-497">
                GARANTÍA DE 7 DÍAS
              </Text>
              <Text fontSize="md" color="whiteAlpha.700" lineHeight="1.5" data-id="element-498">
                Pruébalo 7 días. Si no ves resultados: <br data-id="element-499" />
                <Text as="span" color="#ffd700" fontWeight="bold" data-id="element-500">
                  👉 Te devolvemos el 100%.
                </Text>
              </Text>
            </Box>
          </Flex>

          {/* 19. URGENCIA */}
          <Box textAlign="center" color="red.400" bg="rgba(245, 101, 101, 0.05)" p={6} borderRadius="xl" border="1px solid rgba(245, 101, 101, 0.1)" data-id="element-501">
            <Text fontSize="xl" fontWeight="bold" mb={2} data-id="element-502">
              ⚠️ Este precio es limitado.
            </Text>
            <Text fontSize="lg" color="whiteAlpha.800" data-id="element-503">
              Cuando se agote… Sube automáticamente.
            </Text>
          </Box>

          {/* 20. CIERRE */}
          <Box textAlign="center" px={{
          base: 4,
          md: 8
        }} pt={8} data-id="element-504">
            <Text fontSize="2xl" mb={6} color="whiteAlpha.800" fontWeight="light" data-id="element-505">
              Si el dinero siempre se te escapa…
            </Text>
            <Text fontSize="3xl" fontWeight="bold" color="#ffd700" mb={6} fontFamily="'Playfair Display', Georgia, serif" data-id="element-506">
              No es tu culpa.
            </Text>
            <Text fontSize="2xl" mb={8} color="whiteAlpha.800" fontWeight="light" data-id="element-507">
              Tu sistema está bloqueado.
            </Text>
            <Text fontSize="3xl" fontWeight="black" color="white" data-id="element-508">
              Pero ahora… Tienes una forma de cambiarlo.
            </Text>
          </Box>

          {/* 21. CTA FINAL */}
          <Box textAlign="center" pb={12} data-id="element-509">
            <CTAButton text="QUIERO ACTIVAR MI ABUNDANCIA HOY" href={checkoutUrl} onClick={handleCheckoutClick} data-id="element-510" />
            <Flex justify="center" gap={8} mt={8} color="whiteAlpha.600" fontSize="sm" flexWrap="wrap" textTransform="uppercase" letterSpacing="widest" data-id="element-511">
              <Flex align="center" gap={2} data-id="element-512">
                <Text color="#ffd700" data-id="element-513">✔</Text> Acceso inmediato
              </Flex>
              <Flex align="center" gap={2} data-id="element-514">
                <Text color="#ffd700" data-id="element-515">✔</Text> Pago seguro
              </Flex>
              <Flex align="center" gap={2} data-id="element-516">
                <Text color="#ffd700" data-id="element-517">✔</Text> Sin riesgo
              </Flex>
            </Flex>
          </Box>
        </VStack>
      </Container>

      {/* Purchase Notification */}
      <Box position="fixed" bottom={{
      base: 4,
      md: 6
    }} left={{
      base: 4,
      md: 6
    }} zIndex={998} maxW="340px" transform={showNotification ? 'translateX(0)' : 'translateX(-120%)'} opacity={showNotification ? 1 : 0} transition="all 0.5s cubic-bezier(0.4, 0, 0.2, 1)" data-id="element-518">
        <Box bg="rgba(15, 23, 42, 0.95)" border="1px solid rgba(255, 215, 0, 0.3)" borderRadius="xl" p={4} boxShadow="0 20px 40px rgba(0,0,0,0.6), 0 0 20px rgba(255, 215, 0, 0.1)" data-id="element-519">
          <Flex align="center" gap={3} data-id="element-520">
            <Flex w="40px" h="40px" borderRadius="full" bg="rgba(255, 215, 0, 0.15)" border="1px solid rgba(255, 215, 0, 0.3)" align="center" justify="center" flexShrink={0} data-id="element-521">
              <Text fontSize="lg" data-id="element-522">🛒</Text>
            </Flex>
            <Box flex="1" data-id="element-523">
              <Text fontSize="sm" color="white" fontWeight="bold" lineHeight="1.3" data-id="element-524">
                {purchases[currentPurchase].name}
              </Text>
              <Text fontSize="xs" color="whiteAlpha.800" lineHeight="1.4" data-id="element-525">
                compró{' '}
                <Text as="span" color="#ffd700" fontWeight="bold" data-id="element-526">
                  Protocolo 888
                </Text>{' '}
                por $28.88
              </Text>
              <Flex align="center" gap={2} mt={0.5} data-id="element-527">
                <Text fontSize="xs" color="whiteAlpha.500" data-id="element-528">
                  📍 {purchases[currentPurchase].city}
                </Text>
                <Text fontSize="xs" color="whiteAlpha.400" data-id="element-529">
                  • {purchases[currentPurchase].time}
                </Text>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>;
}